import { useCreateSalesContractMutation } from "@/features/dashboard/api/queries/sales-contract-query";
import type { SalesContractFormData } from "@/features/dashboard/types/sales-contract";
import { toast } from "sonner";
import { useModalControl } from "../core/modals/use-modal-controller";
import { SalesContractForm } from "./sales-contract-form";

interface CreateContractModalProps {
	onSuccess?: () => void;
}

export const CreateContractModal: React.FC<CreateContractModalProps> = ({ onSuccess }) => {
	const { closeModal } = useModalControl();
	const createMutation = useCreateSalesContractMutation();

	const handleSubmit = async (values: SalesContractFormData) => {
		try {
			await createMutation.mutateAsync(values);

			// Show different success messages based on contract type
			if (values.monthly_recurring_sales > 0 && values.payment_type) {
				toast.success("Recurring contract created successfully with invoices auto-generated");
			} else {
				toast.success("One-time contract created successfully with invoice auto-generated");
			}

			onSuccess?.();
			closeModal();
		} catch (error) {
			console.error(error);
			toast.error("Failed to create sales contract");
		}
	};

	return <SalesContractForm onSubmit={handleSubmit} isLoading={createMutation.isPending} />;
};
